import { Text } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

/**
 * Shown while the browser reports no network connection.
 */
export const OfflineBanner = () => {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      css={theme => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: `${theme.space.Space2} ${theme.space.Space4}`,
        backgroundColor: theme.semantic.ColorBackgroundFixedDefault,
      })}
    >
      <Text
        size="sm"
        weight="bold"
        css={theme => ({
          color: theme.semantic.ColorContentOnBackgroundFixedDefault,
        })}
      >
        {t('authenticatedAppView_youAreOffline_header')}
      </Text>
    </div>
  )
}
